import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { LanguageId } from '@/features/language/types'
import { fetchNickname, suggestNickname, updateNickname } from './api'
import type { Nickname } from './types'

/**
 * 질의 키에 값을 넣지 않는다. 키는 devtools와 오류 보고에 그대로 실린다.
 */
export const nicknameKeys = {
  all: ['nickname'] as const,
}

export function useNickname(enabled: boolean) {
  return useQuery({
    queryKey: nicknameKeys.all,
    queryFn: ({ signal }) => fetchNickname(signal),
    enabled,
    /* 이 값을 그리는 화면이 설정 하나뿐이라 그 화면을 여는 동안만 들고 있는다. */
    gcTime: 0,
  })
}

export function useUpdateNickname() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateNickname,
    onSuccess: (saved) => queryClient.setQueryData<Nickname>(nicknameKeys.all, saved),
  })
}

/**
 * 후보를 받는다. 저장하지 않으므로 Cache에 넣지 않는다.
 *
 * 다시 짓기는 그때의 화면 언어로 짓는다. 계정이 설 때 협상 결과로 지은 것은 이 사람이 무슨
 * 언어를 읽는지에 대한 그 순간의 유일한 단서였고, 이 버튼을 누르는 사람은 설정을 그 언어로
 * 읽고 있어 단서가 아니라 사실이 있다.
 */
export function useSuggestNickname() {
  return useMutation({
    mutationFn: (languageId: LanguageId) => suggestNickname(languageId),
  })
}
